"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DisabilityPageTwo;
var _react = _interopRequireDefault(require("react"));
var _formik = require("formik");
var _CollapseInfo = _interopRequireDefault(require("../Wizard/CollapseInfo"));
var _utils = require("../../middleware/utils");
var _DisabilityRefineModal = _interopRequireDefault(require("./DisabilityRefineModal"));
var _DisclosureModal = _interopRequireDefault(require("../Wizard/DisclosureModal"));
var _DisabilityWizardCalculator = require("./DisabilityWizardCalculator.config");
var _PopoverAndOverlay = require("../Wizard/PopoverAndOverlay");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function DisabilityPageTwo(_ref) {
  var _apiData$data, _apiData$data2, _apiData$data3, _apiData$data4, _apiData$data6, _apiData$data7;
  var {
    apiData,
    refinementHandleClose,
    snapshot,
    showRefineModal,
    fetchDataScienceResults,
    disclosureHandleClose,
    showDisclosure
  } = _ref;
  var {
    values: {
      planningIndicator,
      cashSavings
    }
  } = (0, _formik.useFormikContext)();
  var description = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Without using your savings, if you were unable to return to work for", ' ', apiData === null || apiData === void 0 || (_apiData$data = apiData.data) === null || _apiData$data === void 0 || (_apiData$data = _apiData$data.yearsToCover) === null || _apiData$data === void 0 ? void 0 : _apiData$data[0], " years", ' ', /*#__PURE__*/_react.default.createElement(_PopoverAndOverlay.PopoverAndOverlay, {
    fieldName: 'yearsToCover',
    text: _DisabilityWizardCalculator.popoverConfig.yearsToCover
  }), ' ', ", your projected expenses while you're disabled would be", ' ');
  var label = "Income shortfall per month if you became disabled";
  var total = (0, _utils.numberToCurrencyString)(apiData === null || apiData === void 0 || (_apiData$data2 = apiData.data) === null || _apiData$data2 === void 0 || (_apiData$data2 = _apiData$data2.monthlyGap) === null || _apiData$data2 === void 0 ? void 0 : _apiData$data2[0]);
  var id = 'incomeShortfall';
  var array1 = [{
    label: 'Your monthly expenses',
    value: (0, _utils.numberToCurrencyString)(apiData === null || apiData === void 0 || (_apiData$data3 = apiData.data) === null || _apiData$data3 === void 0 || (_apiData$data3 = _apiData$data3.monthlyExpenses) === null || _apiData$data3 === void 0 ? void 0 : _apiData$data3[0]),
    id: 'monthlyExpenses'
  }, {
    label: "Your monthly disability benefit ",
    value: (0, _utils.numberToCurrencyString)(apiData === null || apiData === void 0 || (_apiData$data4 = apiData.data) === null || _apiData$data4 === void 0 || (_apiData$data4 = _apiData$data4.employerMonthlyBenefit) === null || _apiData$data4 === void 0 ? void 0 : _apiData$data4[0]),
    id: 'monthlyDisabilityBenefit',
    popoverText: 'Monthly disability benefit calculation does not reflect the impact of any income taxes that may apply to disability plan benefits.',
    popoverId: 'monthsToSavingsDepletion'
  }];
  if (isPlanningToUseSavings(planningIndicator)) {
    var _apiData$data5;
    array1.push({
      label: "Months until your ".concat((0, _utils.numberToCurrencyString)(cashSavings), " savings is depleted"),
      value: "".concat(apiData === null || apiData === void 0 || (_apiData$data5 = apiData.data) === null || _apiData$data5 === void 0 || (_apiData$data5 = _apiData$data5.monthsToSavingsDepletion) === null || _apiData$data5 === void 0 ? void 0 : _apiData$data5[0], " Months"),
      id: 'timeUntilDepletion'
    });
  }
  array1.push({
    label: "Years disabled ",
    value: "".concat(apiData === null || apiData === void 0 || (_apiData$data6 = apiData.data) === null || _apiData$data6 === void 0 || (_apiData$data6 = _apiData$data6.yearsToCover) === null || _apiData$data6 === void 0 ? void 0 : _apiData$data6[0], " Years"),
    id: 'yearsDisabled',
    popoverText: 'Average disability claim is 4 years. Source: MassMutual claims data',
    popoverId: 'yearsDisabled'
  });
  var {
    setFieldValue
  } = (0, _formik.useFormikContext)();
  var closeAndResetRefinementModal = snapshot => {
    refinementHandleClose();
    // We might be able to use setValues instead of looping through.
    for (var property in snapshot) {
      setFieldValue(property, snapshot[property], false);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h4", null, description), /*#__PURE__*/_react.default.createElement("h3", {
    className: "data-lg"
  }, (0, _utils.numberToCurrencyString)(apiData === null || apiData === void 0 || (_apiData$data7 = apiData.data) === null || _apiData$data7 === void 0 || (_apiData$data7 = _apiData$data7.cumulativeExpenses) === null || _apiData$data7 === void 0 ? void 0 : _apiData$data7[0])), /*#__PURE__*/_react.default.createElement(_CollapseInfo.default, {
    label: label,
    total: total,
    contentArray: array1,
    id: id,
    openToStart: true
  }), /*#__PURE__*/_react.default.createElement(_DisabilityRefineModal.default, {
    handleClose: closeAndResetRefinementModal,
    snapshot: snapshot,
    show: showRefineModal,
    fetchDataScienceResults: fetchDataScienceResults,
    apiData: apiData
  }), /*#__PURE__*/_react.default.createElement(_DisclosureModal.default, {
    handleClose: disclosureHandleClose,
    show: showDisclosure,
    textArray: disclosureTextArray
  }));
}
var disclosureTextArray = ['This interactive calculator is a self-help tool and is not intended to provide financial advice or product recommendations. The results and explanations generated by this calculator are based upon, and will vary due to, your input and certain assumptions made by us. All projections are hypothetical in nature, do not reflect actual results, and are not guarantees of future results. MassMutual will assume no liability for the use of or reliance on this calculator. For a more accurate and detailed analysis specific to your circumstances, we encourage you to contact a qualified financial professional.', 'The information provided is not written or intended as specific tax or legal advice. MassMutual, its employees and representatives are not authorized to give tax or legal advice. Individuals are encouraged to seek advice from their own tax or legal counsel.', 'Disability income insurance policies issued by Massachusetts Mutual Life Insurance Company, Springfield MA 01111-0001. Policies have exclusions and limitations. For costs and complete details of coverage call your agent or MassMutual at 1-800-272-2216 for a referral to an agent.'];
var isPlanningToUseSavings = planningInd => {
  return planningInd == 'plan';
};